var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('audio',{attrs:{"id":"message_ringtone","src":"/incoming_message.mp3","muted":""}}),_vm._v(" "),_c('audio',{attrs:{"id":"conversation_ringtone","src":"/incoming_conversation.mp3","muted":""}})])
}]

export { render, staticRenderFns }